import { useExperience } from '@unisporkal/experiences';
import { useSuspenseQuery } from '@tanstack/react-query';
import useApi from '../useApi';
import type { SubscriptionInfo } from './subscriptionService';
import { SUBSCRIPTION_QUERY_KEYS } from './keys';

type UseSubscriptionInfoParams = {
  family: string;
  isAuthenticated: boolean;
  isRemembered: boolean;
};

const DEFAULT_SUBSCRIPTION_INFO: SubscriptionInfo = {
  hasRfSubscription: false,
  isEligible: false,
  eligibleSubscriptions: {
    gettyCreativeRFSubscription: false,
    gettyEditorialRFSubscription: false,
  },
};

const useSubscriptionInfo = ({
  family,
  isAuthenticated,
  isRemembered,
}: UseSubscriptionInfoParams) => {
  const { subscriptionService } = useApi();
  const subscriptionExperience = useExperience('GettySingleSeatSubscription');
  const isSubscriptionExperienceActive =
    subscriptionExperience?.isActive?.() ?? false;

  const fetchSubscriptionInfo = async (): Promise<SubscriptionInfo> => {
    if (
      (!isAuthenticated && !isRemembered) ||
      !isSubscriptionExperienceActive
    ) {
      return DEFAULT_SUBSCRIPTION_INFO;
    }
    return await subscriptionService.getSubscriptionInfo(family);
  };

  const query = useSuspenseQuery<SubscriptionInfo>({
    queryKey: SUBSCRIPTION_QUERY_KEYS.subscriptionInfo(family),
    queryFn: fetchSubscriptionInfo,
  });
  return { ...query, response: query.data };
};

export default useSubscriptionInfo;
